module.exports = __webpack_public_path__ + "img/369camera.7f446bdf(3).8d25d553.png";